module.exports = __webpack_public_path__ + "img/CCMA.df7895d9b6eff1f922434fd749f7bc3d.jpg";